import React from "react";
import {useTranslation} from "react-i18next";
import {PIE_OPTIONS} from "../Requested/Model/Models";
import {Pie} from "react-chartjs-2";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const PieWhiteListEmpty = ({
    summary
}) => {
    const {t} = useTranslation();
    const total =
        (summary?.[0]?.total || 0) +
        (summary?.[1]?.total || 0) +
        (summary?.[2]?.total || 0);

    const data = {
        labels: [
            t(summary?.[0]?.titleTransShort),
            t(summary?.[1]?.titleTransShort),
            t(summary?.[2]?.titleTransShort)
        ],

        datasets: [
            {
                data: [
                    summary?.[0]?.total || 0,
                    summary?.[1]?.total || 0,
                    summary?.[2]?.total || 0
                ],

                backgroundColor: [
                    summary?.[0]?.color,
                    summary?.[1]?.color,
                    summary?.[2]?.color
                ],
            }
        ]
    };

    return (
       <>
           { total > 0 &&
               <div className={"h-180px"}>
                   <Pie
                       data={data}
                       options={PIE_OPTIONS}
                   />
               </div>
           }
       </>
    );
};

export default PieWhiteListEmpty;
